<template>
    <section>
        <b-container fluid>
            <b-card title='Последние 14 дней наблюдались ли у Вас:'>
                <b-form>
                    <b-form-group 
                        id="radio-group-tempIncrease"
                        label="Повышение температуры"
                        label-for="radio-tempIncrease"
                        label-cols-sm="4"
                        label-cols-lg="4"
                        v-slot="{ aria }"
                    >
                        <b-form-radio-group
                            id="radio-tempIncrease"
                            v-model="lastTwoWeeks.tempIncrease"
                            :options="yesNoOptions"
                            :aria-describedby="aria"
                            name="radio-tempIncrease"
                        ></b-form-radio-group>
                    </b-form-group>
                    <b-form-group 
                        id="radio-group-soreThroat"
                        label="Боль в горле"
                        label-for="radio-soreThroat"
                        label-cols-sm="4"
                        label-cols-lg="4"
                        v-slot="{ aria }"
                    >
                        <b-form-radio-group
                            id="radio-soreThroat"
                            v-model="lastTwoWeeks.soreThroat"
                            :options="yesNoOptions"
                            :aria-describedby="aria"
                            name="radio-soreThroat"
                        ></b-form-radio-group>
                    </b-form-group>
                    <b-form-group 
                        id="radio-group-loss-of-smell"
                        label="Потеря обоняния"
                        label-for="radio-loss-of-smell"
                        label-cols-sm="4"
                        label-cols-lg="4"
                        v-slot="{ aria }"
                    >
                        <b-form-radio-group
                            id="radio-loss-of-smell"
                            v-model="lastTwoWeeks.lossOfSmell"
                            :options="yesNoOptions"
                            :aria-describedby="aria"
                            name="radio-loss-of-smell"
                        ></b-form-radio-group>
                    </b-form-group>
                    <b-form-group 
                        id="radio-group-runny-nose"
                        label="Насморк"
                        label-for="radio-runny-nose"
                        label-cols-sm="4"
                        label-cols-lg="4"
                        v-slot="{ aria }"
                    >
                        <b-form-radio-group
                            id="radio-runny-nose"
                            v-model="lastTwoWeeks.runnyNose"
                            :options="yesNoOptions"
                            :aria-describedby="aria"
                            name="radio-runny-nose"
                        ></b-form-radio-group>
                    </b-form-group>
                    <b-form-group 
                        id="radio-group-loss-of-taste"
                        label="Потеря вкуса"
                        label-for="radio-loss-of-taste"
                        label-cols-sm="4"
                        label-cols-lg="4"
                        v-slot="{ aria }"
                    >
                        <b-form-radio-group
                            id="radio-loss-of-taste"
                            v-model="lastTwoWeeks.lossOfTaste"
                            :options="yesNoOptions"
                            :aria-describedby="aria"
                            name="radio-loss-of-taste"
                        ></b-form-radio-group>
                    </b-form-group>
                    <b-form-group 
                        id="radio-group-cough"
                        label="Кашель"
                        label-for="radio-cough"
                        label-cols-sm="4"
                        label-cols-lg="4"
                        v-slot="{ aria }"
                    >
                        <b-form-radio-group
                            id="radio-cough"
                            v-model="lastTwoWeeks.cough"
                            :options="yesNoOptions"
                            :aria-describedby="aria"
                            name="radio-cough"
                        ></b-form-radio-group>
                    </b-form-group>
                    <b-form-group 
                        id="radio-group-difficulty-breathing"
                        label="Затруднение дыхания"
                        label-for="radio-difficulty-breathing"
                        label-cols-sm="4"
                        label-cols-lg="4"
                        v-slot="{ aria }"
                    >
                        <b-form-radio-group
                            id="radio-difficulty-breathing"
                            v-model="lastTwoWeeks.difficultyBreathing"
                            :options="yesNoOptions"
                            :aria-describedby="aria"
                            name="radio-difficulty-breathing"
                        ></b-form-radio-group>
                    </b-form-group>
                </b-form>
            </b-card>
        </b-container>
    </section>
</template>

<script>
import { mapState, mapMutations, mapActions } from "vuex"

export default {
    name: "last-two-weeks",
    data() {
        return {
            yesNoOptions: [
                { text: "Нет", value: 1 },
                { text: "Да", value: 2 },
            ],
            lastTwoWeeks: {
                tempIncrease: "",
                soreThroat: "",
                lossOfSmell: "",
                runnyNose: "",
                lossOfTaste: "",
                cough: "",
                difficultyBreathing: "",
            },
            answers: []
        }
    },
    methods: {
        ...mapActions('interview', ['sendUserAnswers']),


        concatAnswers() {
            let cnt = 51;
            for (let [key, value] of Object.entries(this.lastTwoWeeks)) {
                if (typeof value === "number") {
                    let obj = {
                        id_question: cnt + 1,
                        int_answer: value,
                        text_answer: ""
                    }
                    this.answers.push(obj);
                    cnt += 1;
                } else {
                    if (value !== null) {
                        let obj = {
                            id_question: cnt + 1,
                            int_answer: 0,
                            text_answer: value
                        }
                        this.answers.push(obj);
                        cnt += 1;
                    }
                }
            }
            this.sendUserAnswers(this.answers);
        }
    },
    computed: {
        
    }
}
</script>


// WEBPACK FOOTER //
// src/components/interview-components/LastTwoWeeks.vue